import InstalledAppDto from "~/models/InstalledAppDto";

export default new InstalledAppDto({ identifier: "anybill-email-marketing" });
